<div class="image-container">
  <div class="text-container">
    <div class="locked-title fs-40 fw-600 ta_center">
      {{ 'SIDENAV.LOCKED_TITLE' | fallbackTranslate }}
    </div>
    <div class="locked-title-2 fw-600 fs-24 ta_center">
      {{ 'SIDENAV.MISS_YOU_TEXT' | fallbackTranslate }}
    </div>
  </div>
  <img
    [src]="images?.PROMISE_LOCK_IMG"
    alt="Promise Image"
    class="payment-image"
  />
</div>

<div class="p-16">
  <div class="system-locked fs-24 m-b-5 fw-600 ta_center gap-1">
    {{ 'SIDENAV.SYSTEM_LOCKED' | fallbackTranslate
    }}<span class="red-locked">{{ 'SIDENAV.LOCKED' | fallbackTranslate }}!</span>
  </div>
  <div class="fs-16 fw-400 clr-333 m-b-5 multiple-reminders ta_center gap-1">
    {{ 'SIDENAV.AFTER_MULTIPLE_REMINDERS' | fallbackTranslate }}
  </div>
  <div class="color-333 fs-16 fw-600 ta_center m-b-10 lh">
    {{ 'SIDENAV.TALK_TO_EXPERT_TEXT' | fallbackTranslate }}
  </div>
  <div class="flex flex_column gap-4 button-margin">
    <div class="flex flex_sb wd-100 gap-6 m-t-15 m-b-10">
      <div
        class="flex flex-1 flex-center header-btn secondary fs-16 fw-400 c-pointer"
        (click)="talkToExpert()"
      >
        {{ 'TALK_TO_EXPERT' | fallbackTranslate }}
      </div>

      <div
        class="flex flex-1 flex-center header-btn primary fs-16 fw-600 c-pointer"
        (click)="renew()"
      >
        {{ 'RENEW_NOW' | fallbackTranslate }}
      </div>
    </div>
  </div>
</div>
